<template>
  <div>
    <Top :pro-name="item.name" :logo='logo'/>
    <vue-signature v-bind:is-show-sign.sync="isShowSign" @set-sign="setElectronicSignatureFile"></vue-signature>
    <div class="maindiv pproject-wrap">
        <div class="ncont detail" v-if="flow==0">
          <div class="sign-row center-row">
            <a class="sub-button" href="javascript:;" @click="flow=1">立即报名</a>
            <a class="sub-button" href="javascript:;" @click="flow=4">报名查询</a>
          </div>
        </div>

      <div class="ncont detail" v-if="flow==5">
        <div class="sign-row center-row">
          <img src="../../../../assets/images/success.png" style="margin-top: 30vw;"/>
          <label style="text-align: center;color: rgb(19,122,216);font-size: 9vw;font-weight: bolder;">报名成功</label>
          <button class="btn" href="javascript:;" @click="flow=0">返回</button>
        </div>
      </div>

        <div class="ncont detail" v-if="flow==4">
          <div class="sign-row">
            <label>请输入手机号</label>
            <input class="content-select" v-model="search_code"/>
          </div>
          <div class="sign-col center-row" style="height: 34.5vw">
            <button href="javascript:;" @click="searchSign">立即查询</button>
            <button href="javascript:;" @click="flow=0">返回</button>
          </div>
          <!-- <div class="result-sign">
            <div v-for="(item,index) in searchData" @click="selectSearch(index)" class="result-sign-item">
              {{item.name}}-{{item.cid}}-{{special_worker_training_type[item['specialWorkerTraining']?item['specialWorkerTraining']['type']:1]}}
              <span v-if="item.save==1" style="color: green;">(已通过)</span>
              <span v-else-if="item.save==2" style="color: red;">(未通过，{{item.memo}})</span>
              <span v-else style="color: red;">(未审核)</span>
            </div>
          </div> -->
          <div class="result-sign" v-show="showsearchData == 1">
            <div class="result-sign-item">
              {{searchData.name}}-{{searchData.cid}}-{{special_worker_training_type[item['specialWorkerTraining']?item['specialWorkerTraining']['type']:1]}}
              <span v-if="searchData.status==1" style="color: green;">(审核已通过)</span>
              <span v-else-if="searchData.status==2" style="color: red;">(审核未通过<span v-if="searchData.memo">,{{searchData.memo}}</span>)</span>
              <span v-else style="color: red;">(审核中)</span>
            </div>
            <div v-if="searchData.status==2" class="fs14 lh20">
              <div  v-for="(item,index) in searchData.refuseReasonsStringArray">{{index + 1}}. {{item}}</div>
            </div>
          </div>
        </div>

        <div class="step" v-show="flow==1 || flow==2 || flow==3">
          <div class="step-box" :class="{active:flow>=1}">
            <a href="javascript:;" @click="flow=1" v-if="flow>1">
              <img src="../../../../assets/images/gou.png"/>
            </a>
            <a href="javascript:;" @click="flow=1" v-else>1</a>
            <span>第一步</span>
          </div>
          <div class="step-line" :class="{active:flow>1}"></div>
          <div class="step-box" :class="{active:flow>=2}">
            <a href="javascript:;" @click="next_1" v-if="flow>2">
              <img src="../../../../assets/images/gou.png"/>
            </a>
            <a href="javascript:;" @click="next_1" v-else>2</a>
            <span>第二步</span>
          </div>
          <div class="step-line" :class="{active:flow>2}"></div>
          <div class="step-box" :class="{active:flow>=3}">
            <a href="javascript:;" @click="next_2" v-if="flow>3">
              <img src="../../../../assets/images/gou.png"/>
            </a>
            <a href="javascript:;" @click="next_2" v-else>3</a>
            <span>第三步</span>
          </div>
        </div>
        <div class="ncont detail" v-show="flow==1">
          <div class="sign-row">
            <div class="label">
              <label>姓名<span class="content-msg">（<span style='color: red;'>*</span>必填项）</span></label>
            </div>
            <div class="content">
              <div class="content-item">
                <input class="content-select" v-model="info.name" />
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>身份证<span class="content-msg">（<span style='color: red;'>*</span>必填项）</span></label>
            </div>
            <div class="content">
              <div class="content-item">
                <input class="content-select" v-model="info.cid"/>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>手机号<span class="content-msg">（<span style='color: red;'>*</span>必填项）</span></label>
            </div>
            <div class="content">
              <div class="content-item">
                <input class="content-select" v-model="info.phone" />
              </div>
            </div>
          </div>

          <div class="sign-col center-row">
            <button href="javascript:;" style="margin-top: 110px;" @click="next_1">下一步</button>
          </div>
        </div>

        <div class="ncont detail" v-show="flow==2">
          <div class="sign-col">
            <div class="label">
              <label>姓名</label>
            </div>
            <div class="label tright">
              <label>{{info.name}}</label>
            </div>
          </div>

          <div class="sign-col">
            <div class="label">
              <label>身份证</label>
            </div>
            <div class="label tright">
              <label>{{info.cid}}</label>
            </div>
          </div>

          <div class="sign-col">
            <div class="label">
              <label>手机号</label>
            </div>
            <div class="label tright">
              <label>{{info.phone}}</label>
            </div>
          </div>

          <div class="sign-col">
            <div class="label">
              <label>性别</label>
            </div>
            <div class="label tright">
              <label>{{sex_a[sex]}}</label>
            </div>
          </div>

          <div class="sign-col">
            <div class="label">
              <label>生日</label>
            </div>
            <div class="label tright">
              <label>{{birthday}}</label>
            </div>
          </div>

          <div class="hr-div"></div>

          <div class="sign-row">
            <div class="label">
              <label>工作单位<span style='color: red;'>*</span></label>
            </div>
            <div class="content">
              <div class="content-item">
                <input class="content-select" v-model="info.company" />
                <span class="content-msg"></span>
                <div style='margin-top: 5px;color: red;'>（ 没有工作单位请填“无”）</div>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>政治面貌<span style='color: red;'>*</span></label>
            </div>
            <div class="content">
              <div class="content-item">
                <select class="content-select" v-model="info.political_outlook">
                  <option value="">请选择</option>
                  <option v-for="(item,index) in politic_status" :value="index">{{item}}</option>
                </select>
                <span class="content-msg"></span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label">
              <label>学历<span style='color: red;'>*</span></label>
            </div>
            <div class="content">
              <div class="content-item">
                <select class="content-select" v-model="info.education" >
                  <option value="">请选择</option>
                  <option v-for="(item,index) in edu_list" :value="index">{{item}}</option>
                </select>
                <span class="content-msg"></span>
              </div>
            </div>
          </div>
          <div class="sign-row" v-if="item.type==2">
            <div class="label">
              <label>初领证日期<span style='color: red;'>*</span></label>
            </div>
            <div class="content">
              <div class="content-item">
                <input class="content-select" v-model="info.issue_date" type="date" />
                <span class="content-msg"></span>
              </div>
            </div>
          </div>
          <div class="sign-row" v-if="item.type==2">
              <div class="label">
                <label>复审到期日<span style='color: red;'>*</span></label>
              </div>
              <div class="content">
                <div class="content-item">
                  <input class="content-select" v-model="info.review_due_date" type="date" />
                  <span class="content-msg"></span>
                </div>
              </div>
          </div>

            <div class="sign-row">
              <div class="label">
                <label>通讯地址<span style='color: red;'>*</span></label>
              </div>
              <div class="content">
                <div class="content-item">
                  <select class="content-select content-select4" v-model="info.province" >
                    <option value="">请选择</option>
                    <option v-for="(item,index) in province" :value="index">{{item}}</option>
                  </select>
                  <select class="content-select content-select4" v-model="info.city" >
                    <option value="">请选择</option>
                    <option v-for="(item,index) in city" :value="index">{{item}}</option>
                  </select>
                  <select class="content-select content-select4" v-model="info.area" >
                    <option value="">请选择</option>
                    <option v-for="(item,index) in area" :value="index">{{item}}</option>
                  </select>
                  <span class="content-msg"></span>
                </div>
              </div>
            </div>
            <div class="sign-row" style="margin-top: 1vw">
              <div class="content">
                <div class="content-item">
                  <input class="content-select" v-model="info.address" />
                  <span class="content-msg"></span>
                </div>
              </div>
            </div>

          <div class="hr-div"></div>
          <div class="sign-col">
            <div class="label">
              <label>申请作业类别</label>
            </div>
            <div class="label tright">
              <label>{{item.train_type}}</label>
            </div>
          </div>

          <div class="sign-col">
            <div class="label">
              <label>操作项目</label>
            </div>
            <div class="label tright">
              <label>{{item.train_project}}</label>
            </div>
          </div>

          <div class="hr-div"></div>

          <div class="sign-row" >
            <div class="label" style="vertical-align: top;">
              <label>身份证正反面<span class="content-msg" style="display: inline-block">（<span style='color: red;'>*</span>必传）</span></label>
            </div>
            <div class="content-item">
              <upload :images="info.cid_photos" @update-image="getCidFiles" @clear-image="clearCidFiles" max-count="1" :param-width="'40vw'" :param-height="'24.38vw'"/>
              <upload :images="info.cid_photos_back" @update-image="getCidFilesBack" @clear-image="clearCidFilesBack" max-count="1" :param-width="'40vw'" :param-height="'24.38vw'"/>
            </div>
            <span class="label warn-title">
              重要提示: <br>
              1.照片必需是近期、正面、免冠、白底、清晰的本人证件照；（拒绝使用扫描、PS等处理过的图片）。<br>
              2.照片格式应为JPG或JPEG格式，且以考生证件号码加姓名为名字，如“证件号码_张三.jpg”，文件大于30K且小于2M，大于215*300（宽*高）像素。<br>
              3.照片将用于证书打印，照片不符合以上要求将无法通过资格复审。
            </span>
          </div>
          <div class="sign-row">
            <div class="label" style="vertical-align: top;">
              <label>学历证明<span class="content-msg" style="display: inline-block">（<span style='color: red;'>*</span>必传）</span></label>
            </div>
            <div class="content">
              <div class="content-item">
                <upload :images="info.academic_certificate" @update-image="getCertificate"
                  @clear-image="clearCertificate" max-count="1" :param-width="'300px'" :param-height="'215px'" />
              </div>
              <span class="label warn-title">
                重要提示: <br>
                必传，重要提示:
                文件大于30K且小于2M，图像清晰，不要歪斜、扭曲，四周不留杂边）
              </span>
            </div>
          </div>
          <div class="sign-row">
            <div class="label">
              <label>电子签名<span class="content-msg">（<span style='color: red;'>*</span>必填项）</span></label>
            </div>
            <div class="content">
              <div class="content-item signature" @click="isShowSign=true">
                <input type="checkbox" class="content-select" style="width: 7.82vw" v-model="!!info.electronic_signature"/>
                <img v-if="info.electronic_signature" :src="electronic_signature_jpg" style="width: 62.58vw;height: 41.4vw;flex-grow: 1;"/>
              </div>
            </div>
          </div>
          <div class="sign-row">
            <div class="label" style="vertical-align: top;">
              <label>本人承诺<input type="checkbox" value="1" v-model="info.is_permit" style="display: inline-block;vertical-align: middle;margin-left: 1vw"/></label>
            </div>
            <div class="content">
              <div class="content-item">
                <span style="display: inline-block;width: 575px;font-size: 3.22vw;color:#666666" v-if="item.type==1">　　本人身体健康，并无妨碍从事相应特种作业 器质性心脏病、癫痫病、美尼尔氏症、昡晕症、癔病、震颤麻痹症、精神病、痴呆症以及其他疾病和生理缺陷。填写的个人信息和报名材料内容真实。
                  　　本人对以上信息的真实性负责，如有隐瞒，相关责任全部由本人承担。<br />
　　根据《特种作业人员安全技术培训考核管理规定》：特种作业操作资格考试包括安全技术理论考试和实际操作考试两部分。考试不及格的，允许补考１次。首次补考不及格的，可再参加一轮考试，经补考，仍不及格的，重新参加相应的安全技术培训。
                </span>
                <span style="display: inline-block;width: 575px;font-size: 3.22vw;color:#666666" v-else>　　自取证以来一直从事相应作业，没有违章操作造成严重后果，没有２次以上违章行为；没有其他安全生产违法行为受到行政处罚的情况。<br />
　　本人身体健康，并无妨碍从事相应特种作业 器质性心脏病、癫痫病、美尼尔氏症、昡晕症、癔病、震颤麻痹症、精神病、痴呆症以及其他疾病和生理缺陷。填写的个人信息和报名材料内容真实。本人对以上信息的真实性负责，如有隐瞒，相关责任全部由本人承担。<br />
　　考试不及格的，允许补考１次。首次补考不及格的，可再参加一轮考试，经补考，仍不及格的，重新参加相应的安全技术培训。
                </span>
              </div>
            </div>
          </div>

          <div class="sign-col center-row">
            <button href="javascript:;" @click="next_2" style="margin:11.5vw auto;">下一步</button>
          </div>
        </div>

        <div class="ncont detail" v-show="flow==3">
          <div class="sign-row">
            <div class="label">
              <label>常住地地址</label>
            </div>
            <div class="content">
              <div class="content-item">
                <input class="content-select" v-model="info.address" />
                <span class="content-msg"></span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label label-top">
              <label>本人健康状况</label>
            </div>
            <div class="content">
              <div class="content-item-col">
                <span class="check-span">1.健康<input type="checkbox" value="1" v-model="info.is_health"/></span>
                <span class="check-span">2.有症状：
                  发热<input type="checkbox" v-model="info.symptom" value="1" :disabled="info.is_health"/>
                  咳嗽<input type="checkbox" v-model="info.symptom" value="2" :disabled="info.is_health"/>
                  胸闷<input type="checkbox" v-model="info.symptom" value="3" :disabled="info.is_health"/>
                  乏力<input type="checkbox" v-model="info.symptom" value="4" :disabled="info.is_health"/>
                  其他<input type="checkbox" v-model="info.symptom" value="5" :disabled="info.is_health"/>
                </span>
                <span class="check-span">3.健康码：
                  绿码<input type="radio" value="1" v-model="info.health_code"/>
                  黄码<input type="radio" value="2" v-model="info.health_code"/>
                  红码<input type="radio" value="3" v-model="info.health_code"/>
                </span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label label-top">
              <label>共同生活人员健康状况</label>
            </div>
            <div class="content">
              <div class="content-item-col">
                <span class="check-span">1.健康<input type="checkbox" value="1" v-model="info.living_together_health"/></span>
                <span class="check-span">2.有症状：
                  发热<input type="checkbox" v-model="info.living_together_symptom" value="1" :disabled="info.living_together_health"/>
                  咳嗽<input type="checkbox" v-model="info.living_together_symptom" value="2" :disabled="info.living_together_health"/>
                  胸闷<input type="checkbox" v-model="info.living_together_symptom" value="3" :disabled="info.living_together_health"/>
                  乏力<input type="checkbox" v-model="info.living_together_symptom" value="4" :disabled="info.living_together_health"/>
                  其他<input type="checkbox" v-model="info.living_together_symptom" value="5" :disabled="info.living_together_health"/>
                </span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label label-top">
              <label>本人旅行史</label>
            </div>
            <div class="content">
              <div class="content-item-col">
                <span class="check-span">1.无<input type="radio" v-model="info.is_travel" value="0" /></span>
                <span class="check-span">2.有<input type="radio" v-model="info.is_travel" value="1" />
                  到过地方<input class="content-select check-text" v-model="info.travel_place" :disabled="info.is_travel!='1'"/></span>
                <span class="check-span">3.现居住地：
                  常住地<input type="radio" value="1" v-model="info.is_stay_regularly"/>
                  其他地方<input type="radio" value="0" v-model="info.is_stay_regularly" />
                  <input class="content-select check-text" v-model="info.other_place" :disabled="info.is_stay_regularly!='0'"/>
                </span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label label-top">
              <label>常住地疫情情况</label>
            </div>
            <div class="content">
              <div class="content-item-col">
                <span class="check-span">近14天内有无发生疫情？</span>
                <span class="check-span">1.无<input type="radio" value="0" v-model="info.is_stay_regularly_safe"/></span>
                <span class="check-span">2.有<input type="radio" value="1" v-model="info.is_stay_regularly_safe"/>具体情况</span>
                <span class="check-span">
                  本土病例<input type="checkbox" :disabled="info.is_stay_regularly_safe != 1" value="1" v-model="info.case_type"/>
                  境外输入病例<input type="checkbox" :disabled="info.is_stay_regularly_safe != 1" value="2" v-model="info.case_type"/>
                  无症状感染病例<input type="checkbox" :disabled="info.is_stay_regularly_safe != 1" value="3" v-model="info.case_type"/>
                </span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label label-top">
              <label>人员接触情况</label>
            </div>
            <div class="content">
              <div class="content-item-col">
                <span class="check-span">近14天内有无接触涉疫人员？</span>
                <span class="check-span">1.无<input type="radio" value="0" v-model="info.is_contact_sick"/></span>
                <span class="check-span">2.有<input type="radio" value="1" v-model="info.is_contact_sick"/>
                  有接触过：确诊病人<input type="checkbox" :disabled="info.is_contact_sick != 1" value="1" v-model="info.contact_sick_type"/>
                  疑似病人<input type="checkbox" :disabled="info.is_contact_sick != 1" value="2" v-model="info.contact_sick_type"/>
                  无症状感染者<input type="checkbox" :disabled="info.is_contact_sick != 1" value="3" v-model="info.contact_sick_type"/>
                </span>
                <span class="check-span">与上述3类人员有接触者<input type="checkbox" :disabled="info.is_contact_sick != 1" value="4" v-model="info.contact_sick_type"/></span>
              </div>
            </div>
          </div>

          <div class="sign-row">
            <div class="label label-top">
              <label>本人承诺</label>
            </div>
            <div class="content">
              <div class="content-item">
                <span class="check-span">本人对以上所天内容的真实性和完整性负责，自愿接受监督和核查</span>
              </div>
            </div>
          </div>
          <div class="sign-col center-row" v-if="cansub == 1">
            <button href="javascript:;" @click="next_3" style="margin:11.5vw auto;">完成提交</button>
          </div>
          <div class="sign-row center-row" v-else>
            <button href="javascript:;" class="sub-button1" style="margin:11.5vw auto;">完成提交</button>
          </div>
        </div>
    </div>
    <Bottom :site-name="site_name"/>
  </div>
</template>

<script>
import Top from '../top'
import Bottom from '../bottom'
import Upload from '../../../item/upload'
import vueSignature from '../../../item/vueSignatureMobile'
export default {
  name: 'detail',

  components: {
    Top,
    Bottom,
    Upload,
    vueSignature
  },

  data () {
    return {
	    'logo': '',
      site_name: '',
      cansub: 1,
      showsearchData: '',
      search_code: '',
      searchData: [],
      special_worker_training_type: [],
      cidFiles: '',
      cidFilesBack: '',
      certificateFiles: '',
      fileCid: '',
      fileCidBack: '',
      fileCertificate: '',
      sex_a: {1: '男', 2: '女'},
      flow: 0,
      item: {
        type: 1,
        train_project: '',
        train_type: ''
      },
      edu_list: [],
      politic_status: [],
      sex: '',
      birthday: '',
      isShowSign: false,
      electronicSignatureFile: '',
      electronic_signature_jpg: '',
      province: [],
      city: [],
      area: [],
      info: {
        id: 0,
        period: 0,
        train_id: 0,
        save: 0,
        is_permit: 0,
        name: '',
        cid: '',
        phone: '',
        company: '',
        education: '',
        political_outlook: '',
        address: '',
        is_health: false,
        symptom: [],
        health_code: 0,
        living_together_health: false,
        living_together_symptom: [],
        is_travel: '',
        travel_place: '',
        is_stay_regularly: '',
        other_place: '',
        is_stay_regularly_safe: '',
        case_type: [],
        is_contact_sick: '',
        contact_sick_type: [],
        remark: '',
        cid_photos: '',
        cid_photos_back: '',
        electronic_signature: '',
        province: 33,
        city: 3310,
        area: 0
      }
    }
  },

  watch: {
    'info.is_contact_sick': {
      deep: true,
      handler: function (n, o) {
        if (n != '1') {
          this.info.contact_sick_type = []
        }
      }
    },
    'info.is_stay_regularly_safe': {
      deep: true,
      handler: function (n, o) {
        if (n != '1') {
          this.info.case_type = []
        }
      }
    },
    'info.is_stay_regularly': {
      deep: true,
      handler: function (n, o) {
        if (n != '0') {
          this.info.other_place = ''
        }
      }
    },
    'info.is_health': {
      deep: true,
      handler: function (n, o) {
        if (n == true) {
          this.info.symptom = []
        }
      }
    },
    'info.living_together_health': {
      deep: true,
      handler: function (n, o) {
        if (n == true) {
          this.info.living_together_symptom = []
        }
      }
    },
    'info.is_travel': {
      deep: true,
      handler: function (n, o) {
        if (n != '1') {
          this.info.travel_place = ''
        }
      }
    },
    'info.cid': {
      handler: function (n, o) {
        if (this.$request.isCard(n)) {
          this.getSignInfo()
        }
      }
    },
    'info.province': {
      immediate: true,
      handler: function (n, o) {
        if (n) {
          this.getCityInfo()
        } else {
          this.city = []
          this.info.city = ''
        }
      }
    },
    'info.city': {
      immediate: true,
      handler: function (n, o) {
        if (n) {
          this.getAreaInfo()
        } else {
          this.area = []
          this.info.area = ''
        }
      }
    }
  },

  created () {
    // document.title = ''
    this.getLogo()
    this.info.train_id = this.$route.query.id
    this.info.period = this.$route.query.period
    console.log(this.$route.query)
    if (this.$request.isPc()) {
      this.$router.push({path: '/train/project/sign-up-tz', query: {id: this.info.train_id, period: this.info.period}})
    }
    this.getInfoData()
    this.getProvinceInfo()
    var cid = this.$route.query.cid
    if (cid) {
      this.flow = 1
      this.info.cid = cid
    }
  },

  mounted () {

  },

  methods: {
	  getLogo(){
      this.$request.getSims('site/school-info', {}, response => {
        if (response.status == 200 && response.data.code == 200) {
          let data = response.data.data
		      this.logo = data.logo
          document.title = data.site_name
          this.site_name = data.site_name
        }
      }, error => {
           console.log(error)
      })
    },
    setElectronicSignatureFile: function (e, f) {
      this.electronicSignatureFile = e
      this.info.electronic_signature = true
      this.electronic_signature_jpg = f
    },
    selectSearch: function (index) {
      this.info = this.searchData[index]
      this.electronic_signature_jpg = this.$request.file_server + this.info.electronic_signature
      this.$router.push({path: '/train/project/print', query: {id: this.info.id}})
    },
    searchSign: function () {
      var param = {
        phone: this.search_code,
        period: this.info.period
      }
      this.$request.get('training-skill/get-special-worker-enroll-record', param, response => {
        if (response.status == 200 && response.data.code == 200) {
          this.searchData = response.data.data
          this.showsearchData = 1
          // this.flow = 1;
        } else {
          alert('未报名')
        }
      }, error => {
        console.log(error)
      })
    },
    getCidFiles: function (e) {
      this.cidFiles = e.target.files
      this.fileCid = ''
      for (let i = 0; i < e.target.files.length; i++) {
        this.fileCid += e.target.files[i]['name'] + ';'
      }
    },
    clearCidFiles: function (e) {
      this.cidFiles = []
      this.fileCid = ''
    },

    getCidFilesBack: function (e) {
      this.cidFilesBack = e.target.files
      this.fileCidBack = ''
      for (let i = 0; i < e.target.files.length; i++) {
        this.fileCidBack += e.target.files[i]['name'] + ';'
      }
    },
    clearCidFilesBack: function (e) {
      this.cidFilesBack = []
      this.fileCidBack = ''
    },
    // 学历证明
    getCertificate: function (e) {
      this.certificateFiles = e.target.files
      this.fileCertificate = ''
      for (let i = 0; i < e.target.files.length; i++) {
        this.fileCertificate += e.target.files[i]['name'] + ';'
      }
    },
    clearCertificate: function (e) {
      this.certificateFiles = []
      this.fileCertificate = ''
    },

    changeCid: function () {
      this.$refs.fileCid.dispatchEvent(new MouseEvent('click'))
    },
    next_1: function () {
      if (!this.$request.isCard(this.info.cid)) {
        alert('身份证格式不正确')
        return
      }
      if (this.info.name == '') {
        alert('姓名不能为空')
        return
      }
      if (this.info.phone == '') {
        alert('手机号不能为空')
        return
      }
      // if(this.info.save == 1){
      //  if(confirm('检测到该身份证已报名此培训，是否跳转打印，下载？')){
      //    this.flow = 4;
      // }
      // }else{
      this.sex = this.$request.getSex(this.info.cid)
      this.birthday = this.$request.getBirth(this.info.cid)
      this.flow = 2
      // }
    },
    next_2: function () {
      if (!this.info.company) {
        alert('工作单位未填写'); return false
      }
      if (!this.info.political_outlook) {
        alert('政治面貌未选择')
        return false
      }
      if (/** this.item.type==1 && **/!this.info.education) {
        alert('学历未选择'); return false
      }
      if (!this.info.province || !this.info.city || !this.info.area || !this.info.address) {
        alert('通讯地址不完整'); return false
      }
      if (this.item.type == 2 && !this.info.issue_date) {
        alert('初领证日期未选择')
        return false
      }
      if (this.item.type == 2 && !this.info.review_due_date) {
        alert('复审到期日未选择')
        return false
      }
      if (!this.info.is_permit) {
        alert('未勾选本人承诺')
        return
      }
      if (!this.info.electronic_signature) {
        alert('未签名'); return false
      }
      this.flow = 3
    },
    next_3: function () {
      if ((!this.info.is_health && this.info.symptom == 0) || !this.info.health_code) {
        alert('本人健康不完整'); return false
      }
      if (!this.info.living_together_health && this.info.living_together_symptom == 0) {
        alert('共同生活人员健康状况不完整'); return false
      }
      if ((this.info.is_travel != 0 && !this.info.travel_place) || !this.info.is_travel) {
        alert('本人旅行史不完整'); return false
      }
      if ((this.info.is_stay_regularly == 0 && !this.info.other_place) || !this.info.is_stay_regularly) {
        alert('本人旅行史不完整'); return false
      }
      if ((this.info.is_stay_regularly_safe == 1 && this.info.case_type == 0) || !this.info.is_stay_regularly_safe) {
        alert('常住地疫情情况不完整'); return false
      }
      if ((this.info.is_contact_sick == 1 && this.info.contact_sick_type == 0) || !this.info.is_contact_sick) {
        alert('人员接触情况不完整'); return false
      }
      let param = new FormData()
      if (this.cidFiles.length > 0) {
        // for(let i = 0;i < this.cidFiles.length;i++){
        //   let file = this.cidFiles[i];
        //   param.append('cid_photos',file,file.name);
        // }
        param.append('cid_photos', this.cidFiles[0], this.cidFiles[0]['name'])
      } else {
        if (!this.fileCid) {
          alert('身份证正面未上传！'); return false
        }
      }
      if (this.cidFilesBack.length > 0) {
        param.append('cid_photos_back', this.cidFilesBack[0], this.cidFilesBack[0]['name'])
      } else {
        if (!this.fileCidBack) {
          alert('身份证反面未上传！'); return false
        }
      }
      if (this.certificateFiles.length > 0) {
        param.append('academic_certificate', this.certificateFiles[0], this.certificateFiles[0]['name'])
      } else {
        if (!this.fileCertificate) {
          alert('学历证明未上传！')
          return false
        }
      }
      if (!this.info.electronic_signature) {
        alert('未签名！'); return false
      }
      if (this.electronicSignatureFile) {
        param.append('electronic-signature', this.electronicSignatureFile, 'signature.jpg')
      }
      for (let key in this.info) {
        if (key == 'is_permit' || key == 'is_health' || key == 'living_together_health') {
          if (this.info[key] == true) {
            param.append(key, 1)
          } else {
            param.append(key, 0)
          }
        } else if (key == 'save') {
          param.append(key, 1)
        } else {
          param.append(key, this.info[key])
        }
      }
      let config = {
        headers: {'Content-Type': 'multipart/form-data'}
      } // 添加请求头
      this.cansub = 0
      param.append('period', this.info.period)
      this.$request.postFile('training-skill/special-worker-enroll-record', param, config, response => {
        if (response.status == 200 && response.data.code == 200) {
          // 报名成功
          this.cansub = 1
          alert('报名成功')
          this.flow = 5
          // this.$router.push({path:'/train/project/print',query:{id:response.data.data.id}})
        } else {
          this.cansub = 1
          alert(response.data.message)
        }
      }, error => {
        console.log(error)
      })
    },
    getInfoData: function () {
      var id = this.$route.query.id
      var getParam = {}
      getParam['id'] = id
      getParam['period'] = this.info.period
      this.$request.get('training-skill/get-special-worker-train-detail', getParam, response => {
        if (response.status == 200 && response.data.code == 200) {
          this.item = response.data.data.promotionSpecialWorkerTraining
          this.edu_list = response.data.data.edu_level
          this.special_worker_training_type = response.data.data.special_worker_training_type
          this.politic_status = response.data.data.politic_status
        }
      }, error => {
        console.log(error)
      })
    },
    getSignInfo: function () {
      var getParam = {}
      getParam['train_id'] = this.info.train_id
      getParam['cid'] = this.info.cid
      getParam['period'] = this.info.period
      this.$request.get('training-skill/get-special-worker-enroll-record-by-cid', getParam, response => {
        if (response.status == 200 && response.data.code == 200) {
          this.info = response.data.data
          this.electronic_signature_jpg = this.$request.file_server + this.info.electronic_signature
          this.fileCidBack = this.info.cid_photos_back
          this.fileCid = this.info.cid_photos
          this.fileCertificate = this.info.academic_certificate
          if (confirm('检测到该身份证已报名此培训，是否跳转打印，下载？')) {
            this.flow = 4
          }
        } else {
          if (!this.info.id) { this.info.id = 0 }
        }
      }, error => {
        console.log(error)
      })
    },
    getProvinceInfo: function () {
      var getParam = {}
      getParam['parent_id'] = 0
      getParam['period'] = this.info.period
      this.$request.get('region/get-region', getParam, response => {
        if (response.status == 200 && response.data.code == 200) {
          this.province = response.data.data
        }
      }, error => {
        console.log(error)
      })
    },
    getCityInfo: function () {
      var getParam = {}
      getParam['parent_id'] = this.info.province
      getParam['period'] = this.info.period
      this.$request.get('region/get-region', getParam, response => {
        if (response.status == 200 && response.data.code == 200) {
          this.city = response.data.data
        }
      }, error => {
        console.log(error)
      })
    },
    getAreaInfo: function () {
      var getParam = {}
      getParam['parent_id'] = this.info.city
      getParam['period'] = this.info.period
      this.$request.get('region/get-region', getParam, response => {
        if (response.status == 200 && response.data.code == 200) {
          this.area = response.data.data
        }
      }, error => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped>
  .ncont{
    width: 100vw;
    min-height: 143vw;
    background-color: #fff;
  }
  .sign-row{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .sign-row .content-select{
    border: 0.23vw solid #d3d9dd;
    background-color: #f3f3f3;
  }
  .sign-row .content-select,.sign-row .content{
    box-sizing: border-box;
    width:81.88vw;
    min-height: 7.82vw;
  }
  .sign-row label{
    margin-top: 14.26vw;
  }
  .sign-row label,.sign-row .label,.sign-col .label{
    min-height: 9.2vw;
    width: 81.88vw;
    line-height: 9.2vw;
    font-size: 3.68vw;
    color: #666666;
  }
  .sub-button{
    box-sizing: border-box;
    width: 80.04vw;
    height: 17.94vw;
    background-color: #e3edf6;
    color: #147ad8;
    font-size: 5.52vw;
    text-align: center;
    line-height: 17.94vw;
    border-radius: 1.38vw;
  }
  .sub-button:nth-child(1){
    margin-top: 26.22vw;
  }
  .sub-button:nth-child(2){
    margin-top: 7.36vw;
  }
  .sign-col{
    width:81.88vw;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: auto
  }
  .sign-col button{
    box-sizing: border-box;
    width: 37.26vw;
    height: 11.04vw;
    border: #147ad8 solid 0.46vw;
    border-radius: 1.38vw;
    font-size: 4.14vw;
  }
  .sign-col button:nth-child(1){
    background-color: #147ad8;
    color: #fff;
    margin: auto;
  }
  .sign-col button:nth-child(2){
    background-color: #fff;
    color: #147ad8;
  }
  .result-sign{
    width: 81.88vw;
    margin: auto;
    display: flex;
    flex-direction: column;
  }
  .result-sign-item{
    display: flex;
    font-size: 3.68vw;
  }
  .result-sign-item::before{
    content: '';
    width: 4.38vw;
    background-image: url("../../../../assets/images/jt.png");
    background-position: center;
    background-repeat: no-repeat;
    margin-right: 1vw;
  }
  .hr-div{width: 100%;height: 1px;border-top: 0.3vw solid rgb(233,233,233);margin: 6vw 0}
  .content-item{
    width: 80.04vw;
    display: flex;
    flex-direction: row;
  }
  .content-item-col{
    width: 80.04vw;
    display: flex;
    flex-direction: column;
    font-size: 3.22vw;
    color: #666;
    line-height: 5.72vw;
  }
  .content-item-col input[type=checkbox],.content-item-col input[type=radio]{
    vertical-align: middle;
    margin-left: 1vw;
  }
  .content-item-col .content-select{
    width: 25.3vw;
    margin-left: 1vw;
  }
  .sign-row26{
    margin-top: 4.6vw;
  }
  .label.warn-title{
    font-size: 3.22vw;
    color: #94070a;
    line-height: 4.6vw;
    margin-top: 3.22vw;
  }
  .success-div{
    height: 60.5vw;
  }
  .success-title{
    font-size: 5vw;
  }
  .signature{
    position: relative;
  }
  .signature::before{
    content: '';
    display: block;
    z-index: 100;
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .step{
    box-sizing: border-box;
    width:100vw;
    display: flex;
    background: #fff;
    margin-bottom: 1.84vw;
    height: 33.6vw;
    padding: 8.28vw;
    justify-content: space-between;
  }
  .step-box{
    display: flex;
    width: 13.8vw;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }
  .step-box a{
    width: 10.12vw;
    height: 10.12vw;
    text-align: center;
    box-sizing: border-box;
    border-radius: 50%;
    border: 1.8vw solid #f2f2f4;
    background-color: #a5aab2;
    color: #fff;
    font-size: 4.14vw;
    line-height: 7.12vw;
  }
  .step-box span{
    color: #666666;
    font-size: 4.14vw;
  }
  .step-line{
    width: 13.8vw;
    height: 0.5vw;
    background-color: #a5aab2;
    margin-top: 5.06vw;
  }
  .step-line.active{
    background-color: #1379d7;
  }
  .step-box.active a{
    background-color: #1379d7;
    border-color: #e0ebff;
  }
  .step-box.active span{
    color: #147ad8;
  }
  .step-box.active a img{
    width: 6.9vw;
    height: 6.9vw;
    position: relative;
    top: -0.5vw;
    left: 0.8vw;
  }
  .label-top{
    margin-top: 6vw;
  }
  .check-span{
    font-size: 3.22vw;
  }
  .content-select.content-select4{
    width:28.7vw;
    margin-right: 1vw;
  }
  .btn{
    border: none;
    width: 42.04vw;
    height: 10.94vw;
    background: #147AD7;
    color: white;
    border-radius: 5px;
    margin-top: 20px;
    font-size: 4.52vw;
  }
  .sub-button1 {
    display: inline-block;
    width: 180px;
    height: 46px;
    line-height: 46px;
    text-align: center;
    border: 1px solid gray;
    color: gray;
    border-radius: 5px;
  }
</style>


// WEBPACK FOOTER //
// src/components/mobile/train/project/signUpTz.vue